import React, { MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { pathname, forwardUrlParams } from '../../../utils';
import Typography from '@material-ui/core/Typography';
import Link from '../../misc/Link';

export default function ForgotPasswordLink() {
  const history = useHistory();

  function handleClick(e: MouseEvent<HTMLElement>) {
    e.preventDefault();
    history.push({
      pathname: pathname.preLogin.forgotPw.url,
      search: forwardUrlParams(),
    });
  }
  return (
    <Link href="#" onClick={handleClick}>
      <Typography variant="body2">Forgot Password?</Typography>
    </Link>
  );
}
